import { AppFormItemProps, ConditionalRender } from 'components/atoms';
import { VatRatePickerElement } from 'components/molecules/FormElements/VatRatePickerElement/VatRatePickerElement';
import { VatReleaseReasonPickerElement } from 'components/molecules/FormElements/VatReleaseReasonPickerElement/VatReleaseReasonPickerElement';
import { SimpleTextAreaElement } from 'components/molecules/SimpleFormElements';
import { useWatch } from 'rc-field-form';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { VatRateType, VatReleaseReason } from 'types';

type VatRateElementProps = Pick<AppFormItemProps, 'name' | 'label'>;

type VatRateElementsGroupProps = {
    rateTypeFormItemProps: VatRateElementProps;
    releaseReasonFormItemProps: VatRateElementProps;
    customReleaseReasonFormItemProps: VatRateElementProps;
    disabled?: boolean;
    optional?: boolean;
};

export const VatRateElementsGroup = ({
    rateTypeFormItemProps,
    releaseReasonFormItemProps,
    customReleaseReasonFormItemProps,
    disabled,
    optional,
}: VatRateElementsGroupProps) => {
    const formInstance = useFormInstance();

    const rateTypeFormValue = useWatch<VatRateType | undefined>(
        rateTypeFormItemProps.name,
        formInstance,
    );
    const releaseReasonFormValue = useWatch<VatReleaseReason | undefined>(
        releaseReasonFormItemProps.name,
        formInstance,
    );

    const isReleasedRateType = rateTypeFormValue === VatRateType.RELEASED;
    const isCustomReleaseReason = releaseReasonFormValue === VatReleaseReason.CUSTOM;

    return (
        <>
            <VatRatePickerElement
                name={rateTypeFormItemProps.name}
                label={rateTypeFormItemProps.label}
                disabled={disabled}
                optional={optional}
                allowClear={false}
            />
            <ConditionalRender condition={isReleasedRateType}>
                <VatReleaseReasonPickerElement
                    name={releaseReasonFormItemProps.name}
                    label={releaseReasonFormItemProps.label}
                    disabled={disabled}
                    optional={optional}
                    allowClear={false}
                />
                <ConditionalRender condition={isCustomReleaseReason}>
                    <SimpleTextAreaElement
                        name={customReleaseReasonFormItemProps.name}
                        label={customReleaseReasonFormItemProps.label}
                        rows={2}
                        disabled={disabled}
                        optional={optional}
                    />
                </ConditionalRender>
            </ConditionalRender>
        </>
    );
};
